import type { ComponentProps } from 'react';

import type { FieldLayoutOptions } from './useFieldLayout';
import { FormTextInput } from './FormField';
import { useFieldLayout } from './useFieldLayout';

export type TextFieldProps = Omit<
  ComponentProps<typeof FormTextInput>,
  'label' | 'inputHeight' | 'inputBackground'
> &
  FieldLayoutOptions;

export const TextField = ({ label, hideLabel, ...fieldProps }: TextFieldProps) => {
  const field = useFieldLayout({ label, hideLabel });

  return (
    <FormTextInput
      label={field.label}
      aria-label={field.ariaLabel}
      inputHeight={field.inputHeight}
      inputBackground={field.inputBackground}
      {...fieldProps}
    />
  );
};
